import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AppService } from 'src/app/app.service';
import { BasicFilters } from 'src/app/core/services/async-list.service';

@Component({
  selector: 'app-table-filters-container',
  template: `
    <ng-container *ngIf="isMobileView$ | async as isMobileView">
      <h2 *ngIf="!isMobileView.state; else toggleFiltersTemplate" class="font-semibold mb-4">Filtruj parametry:</h2>

      <ng-container *ngIf="!isMobileView.state || filtersExpanded">
        <div class="filters__container">
          <ng-content></ng-content>
        </div>
        <button [disabled]="inProgress" (click)="search()" class="block sky-btn-sky-blue mb-6 w-56 mx-auto">
          Szukaj
        </button>
      </ng-container>
    </ng-container>

    <ng-template #toggleFiltersTemplate>
      <a class="flex items-center" [class.mb-4]="filtersExpanded" (click)="toggleFilters()"
        ><span>Rozwiń filtry</span
        ><sky-svg-icon class="transform ml-2" [class.rotate-180]="!filtersExpanded" icon="chevron-down"></sky-svg-icon
      ></a>
    </ng-template>
  `,
  styles: [
    `
      :host {
        display: block;
        @apply border-b mt-4 -mx-8 px-8 pb-6 mb-4;
      }
    `,
  ],
})
export class TableFiltersContainerComponent<T extends BasicFilters> {
  @Input() public form!: FormGroup;
  @Input() public inProgress = false;
  @Input() public filters$!: BehaviorSubject<T>;
  @Input() public buttonPosition: 'inline' | 'block' = 'block';

  public isMobileView$ = this._appService.isMobileView$.pipe(
    tap(({ state }) => {
      if (!state) {
        this.filtersExpanded = false;
      }
    })
  );
  public filtersExpanded = false;

  constructor(private readonly _appService: AppService) {}

  public toggleFilters() {
    this.filtersExpanded = !this.filtersExpanded;
  }

  public search() {
    this.filters$.next({ ...this.filters$.getValue(), page: 0, ...this.form.value });
  }
}
